<template>
    <div class="body-panel dataContent">
        <div class="body-panel-control separator" v-if="profile != null">
            <div class="control-block-left">
                <p class="caption-help">Изменение личных данных</p>
            </div>
            <div class="control-block-right flex">
                <button class="btn" @click.stop="onShowModal('ppChangePassword')">Сменить пароль</button>
                <button class="btn btn-primary margin-left-20" @click="saveData" v-if="profile.TermsConfirmed" :disabled="errorMessage != null">Сохранить</button>
            </div>
        </div>
        <div class="body-panel-content body-panel-content-page" v-if="profile != null">
            <div class="test-result-header flex profile">
                <div :class="['test-result-header-div', {'select': tabs.active === 'info'}]" @click="tabs.active='info'">Основные данные</div>
                <div :class="['test-result-header-div', {'select': tabs.active === 'docs'}]" @click="tabs.active='docs'; $validator.validateAll('docs')" v-if="info.User && hasClaims(info.User.DynamicRole, claimEnums.bonusSpend)">Документы</div>
                <div :class="['test-result-header-div', {'select': tabs.active === 'card'}]" 
                     @click="tabs.active='card'; $validator.validateAll('card')" 
                     v-if="profile.ProjectsHavePhysicalBankCardReward && info.User && hasClaims(info.User.DynamicRole, claimEnums.bonusSpend)">Банковская карта</div>
                <div :class="['test-result-header-div', {'select': tabs.active === 'external'}]" @click="tabs.active='external'; $validator.validateAll('external')" v-if="external.length && info.User.MainRole !== 'administrators'">Вход через соц. сети</div>
            </div>

            <div class="block-in-page" :style="{display: tabs.active === 'info' ? 'block' : 'none'}">
                <div class="error" v-if="!profile.TermsConfirmed">
                    Для продолжения работы в системе Вы должны согласиться с условиями использования сервиса
                </div>
                <div class="profile-edit">
                    <div class="profile-images">
                        <div class="profile-img margin-bottom-10">
                            <div class="profile-img-cell">
                                <img :src="profile.Image" v-if="profile.Image && !profile.DeleteImage" />
                                <img src="../../img/u57.png" v-else />
                            </div>
                        </div>
                        <div class="file-upload-zone" v-if="!profile.Image || profile.DeleteImage">
                            <input type="file" id="dropFiles" ref="dropFiles" name="dropFiles" class="file-upload-zone-btn" accept=".jpg,.jpeg,.png" />
                            <label id="dropFilesBtnLbl" for="dropFiles" class="file-upload-zone-lbl">Добавьте фото профиля</label>
                        </div>

                        <div id="fileList" v-if="profile.FileName != null" class="fileList">
                            Выбран файл: {{ profile.FileName }}
                        </div>
                        <button type="button" class="btn btn-delete"
                                @click="removeImage()"
                                v-if="(profile.Image || profile.FileName) && !profile.DeleteImage">
                            Удалить
                        </button>

                    </div>
                    <div class="profile-data">
                        <div class="error" v-if="errorMessage">
                            {{ errorMessage.message }}
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Имя
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <input name="FirstName" type="text"
                                   :disabled="!profile.PersonalDataEditingAccept || profile.PassportVerificationState === 1 || profile.PassportVerificationState === 2"
                                   v-model="profile.FirstName"
                                   v-validate="'required'"
                                   data-vv-scope="info"
                                   data-vv-as="Имя"
                                   :class="['input-text', {'input-error': errors.has('FirstName', 'info')}]" >
                            <span class="field-validation-valid"></span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Фамилия
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <input name="LastName" type="text"
                                   :disabled="!profile.PersonalDataEditingAccept || profile.PassportVerificationState === 1 || profile.PassportVerificationState === 2"
                                   v-model="profile.LastName"
                                   v-validate="'required'"
                                   data-vv-scope="info"
                                   data-vv-as="Фамилия"
                                   :class="['input-text', {'input-error': errors.has('LastName', 'info')}]">
                            <span class="field-validation-valid"></span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Отчество
                                <span class="required" aria-required="true"></span>
                            </label>
                            <input name="MiddleName" type="text"
                                   :disabled="!profile.PersonalDataEditingAccept || profile.PassportVerificationState === 1 || profile.PassportVerificationState === 2"
                                   v-model="profile.MiddleName"
                                   data-vv-scope="info"
                                   :class="['input-text', {'input-error': errors.has('MiddleName', 'info')}]">
                            <span class="field-validation-valid"></span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Email
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <input name="Email"
                                   v-model="profile.Email"
                                   v-validate="'required|email'"
                                   data-vv-scope="info"
                                   :class="['input-text', {'input-error': errors.has('Email', 'info')}]" type="text">
                            <span class="field-validation-valid"></span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Телефон
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <the-mask :mask="['### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ###']" name="PhoneNumber"
                                      v-model="profile.PhoneNumber"
                                      v-validate="{ required: true, regex: /^\d{11,}$/ }"
                                      data-vv-scope="info"
                                      data-vv-as="Телефон"
                                      :class="['input-text', {'input-error': errors.has('PhoneNumber', 'info')}]" />
                            <span class="field-validation-valid"></span>
                        </div>
                        <div class="form-field" v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.projectPage) || info.User.MainRole === 'administrators')">
                            <label class="input-text-lbl">
                                Внешний идентификатор
                            </label>
                            <input name="ExternalId" class="input-text" type="text" v-model="profile.ExternalId"/>
                        </div>
                        <div class="form-field">
                            <label class="input-text-lbl">
                                Дата рождения
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <div class="input-date-lbl">
                                <input-date name="BirthDateFormatted"
                                            :disabled="!profile.PersonalDataEditingAccept || profile.PassportVerificationState === 1 || profile.PassportVerificationState === 2"
                                            v-model="profile.BirthDateFormatted"
                                            v-validate="'required'"
                                            data-vv-scope="info"
                                            data-vv-as="Дата рождения"
                                            @input="onChangeDate(profile, 'BirthDateFormatted', 'BirthDate')"
                                            :class="['input-text', {'input-error': errors.has('BirthDateFormatted', 'info')}]"></input-date>
                            </div>
                        </div>
                        <div class="form-field">
                            <label class="input-text-lbl">
                                Пол
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <drop-down v-if="genders.length > 0"
                                       :name="'Sex'"
                                       :items="genders"
                                       :dataField="'Value'"
                                       :textField="'Name'"
                                       :withSelectItem="'true'"
                                       v-model="profile.Sex"
                                       data-vv-as='"Пол"'
                                       v-validate="{required: true}"
                                       data-vv-scope="info"
                                       :class="[{'input-error': errors.has('Sex', 'info')}]"></drop-down>
                            <span class="field-validation-valid">{{ errors.first('Sex') }}</span>
                        </div>
                        <div class="form-field">
                            <input id="NotificationsEnabled" v-model="profile.NotificationsEnabled" name="NotificationsEnabled" value="true" type="checkbox" class="input-checkbox" />
                            <label for="NotificationsEnabled" class="input-checkbox-lbl">Я хочу получать новости и оповещения по email и sms</label>
                        </div>
                        <div class="form-field">
                            <input id="TermsConfirmed" v-model="profile.TermsConfirmed" name="TermsConfirmed" value="true" type="checkbox" class="input-checkbox" :disabled="profile.TermsConfirmed" />
                            <label for="TermsConfirmed" class="input-checkbox-lbl">
                                Я согласен с <a v-if="info.RulesFile" href="javascript:;" @click.stop="onShowRulesClick" style="color:#ff0000">правилами программы</a>
                                <span v-if="!info.RulesFile">правилами программы</span>
                            </label>
                        </div>
                        <div class="form-field">
                            <input id="PersonalDataEditingAccept" v-model="profile.PersonalDataEditingAccept" name="PersonalDataEditingAccept" value="true" type="checkbox" :disabled="profile.PersonalDataEditingAccept" class="input-checkbox" />
                            <label for="PersonalDataEditingAccept" class="input-checkbox-lbl">
                                Я согласен на обработку
                                <a v-if="info.PolicyFile" href="javascript:;" @click.stop="onShowPolicyClick" style="color:#ff0000">персональных данных</a><span v-if="!info.PolicyFile">персональных данных</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="['block-in-page', {'notAllowed' : !profile.PersonalDataEditingAccept || profile.PassportVerificationState === 1 || profile.PassportVerificationState === 2 }]"
                 :style="{display: tabs.active === 'docs' ? 'block' : 'none'}"
                 v-if="info.User && hasClaims(info.User.DynamicRole, claimEnums.bonusSpend)">

                <div class="error" v-if="profile.PassportVerificationState === 0">
                    Данные документов необходимы для того, чтобы Вы могли выбрать приз
                </div>
                <div class="error" v-if="profile.PassportVerificationState === 1">
                    Паспортные данные находятся на проверке
                </div>
                <div class="approve" v-if="profile.PassportVerificationState === 2">
                    Паспортные данные успешно проверены
                </div>
                <div class="error" v-if="profile.PassportVerificationState === 3">
                    Паспортные данные были отклонены по следующей причине:
                    <p style="color:#728a9a">{{ profile.PassportVerificationComment }}</p>
                </div>

                <div class="error" v-if="errorMessage">
                    {{ errorMessage.message }}
                </div>

                <div class="profile-edit" v-if="errorMessage == null || errorMessage.type !== 'birthdate'">
                    <div class="profile-data">
                        <div class="form-field">
                            <label class="input-text-lbl">
                                Вид документа
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <drop-down :items="documentTypes"
                                       :dataField="'Id'"
                                       :textField="'Name'"
                                       v-model="profile.DocumentType"></drop-down>
                        </div>

                        <div class="form-field" v-if="profile.DocumentType === 2">
                            <label class="input-text-lbl">
                                Страна выдачи
                                <span class="required" aria-required="true" v-if="passportFields.PassportIssuedCountry">*</span>
                            </label>
                            <input name="PassportIssuedCountry"
                                   v-model="profile.PassportIssuedCountry"
                                   v-validate ="{ rules: { required: this.passportFieldsRequired && passportFields.PassportIssuedCountry} }"
                                   data-vv-scope="docs"
                                   :class="['input-text', {'input-error': errors.has('PassportIssuedCountry', 'docs')}]" type="text">
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Серия паспорта
                                <span class="required" aria-required="true" v-if="passportFields.PassportSeries && profile.DocumentType !== 2">*</span>
                            </label>
                            <input v-if="profile.DocumentType === 2" class="input-text"
                                   name="PassportSeries2"
                                   v-model="profile.PassportSeries"
                                   type="text" autocomplete="off">
                            <the-mask v-else v-model="profile.PassportSeries"
                                      :mask="PassportSeriesMask"
                                      name="PassportSeries"
                                      v-validate="{ passportSeries: PassportSeriesMaxLength }"
                                      data-vv-scope="docs"
                                      :class="['input-text', {'input-error': errors.has('PassportSeries', 'docs')}]" />
                            <span class="field-validation-valid">{{ errors.first('PassportSeries', 'docs') }}</span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Номер паспорта
                                <span class="required" aria-required="true" v-if="passportFields.PassportNumber && profile.DocumentType !== 2">*</span>
                            </label>
                            <input name="PassportNumber"
                                   v-model="profile.PassportNumber"
                                   v-validate="{ passportNumber: PassportNumberMaxLength }"
                                   data-vv-scope="docs"
                                   :class="['input-text', {'input-error': errors.has('PassportNumber', 'docs')}]" type="text" autocomplete="off">
                            <span class="field-validation-valid">{{ errors.first('PassportNumber', 'docs') }}</span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Кем выдан
                                <span class="required" aria-required="true" v-if="passportFields.PassportIssuedBy">*</span>
                            </label>
                            <input name="PassportIssuedBy"
                                   v-model="profile.PassportIssuedBy"
                                   v-validate ="{ rules: { required: this.passportFieldsRequired && passportFields.PassportIssuedBy} }"
                                   data-vv-scope="docs"
                                   :class="['input-text', {'input-error': errors.has('PassportIssuedBy', 'docs')}]" type="text">
                            <span class="field-validation-valid"></span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Номер подразделения
                                <span class="required" aria-required="true" v-if="passportFields.PassportIssuedCode">*</span>
                            </label>
                            <the-mask :mask="'###-###'" name="PassportIssuedCode"
                                      v-model="profile.PassportIssuedCode"
                                      v-validate="{ rules: { required: this.passportFieldsRequired && passportFields.PassportIssuedCode} }"
                                      data-vv-scope="docs"
                                      data-vv-as="Номер подразделения"
                                      :class="['input-text', {'input-error': errors.has('PassportIssuedCode', 'docs')}]" />
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Дата выдачи
                                <span class="required" aria-required="true" v-if="passportFields.PassportIssuedDateFormatted">*</span>
                            </label>
                            <div class="input-date-lbl">
                                <input-date name="PassportIssuedDateFormatted"
                                            v-model="profile.PassportIssuedDateFormatted"
                                            v-validate ="{ rules: { required: this.passportFieldsRequired && passportFields.PassportIssuedDateFormatted} }"
                                            data-vv-scope="docs"
                                            @input="onChangeDate(profile, 'PassportIssuedDateFormatted', 'PassportIssuedDate')"
                                            :class="['input-text', {'input-error': errors.has('PassportIssuedDateFormatted', 'docs')}]"></input-date>
                            </div>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Адрес регистрации
                                <span class="required" aria-required="true" v-if="passportFields.PassportRegistrationAddress">*</span>
                            </label>
                            <input name="PassportRegistrationAddress"
                                   v-model="profile.PassportRegistrationAddress"
                                   v-validate ="{ rules: { required: this.passportFieldsRequired && passportFields.PassportRegistrationAddress} }"
                                   data-vv-scope="docs"
                                   :class="['input-text', {'input-error': errors.has('PassportRegistrationAddress', 'docs')}]" type="text">
                            <span class="field-validation-valid"></span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                {{profile.DocumentType === 2 ? 'ИНН/ИНП/ИИН' : 'ИНН'}}
                                <span class="required" aria-required="true" v-if="passportFields.Inn">*</span>
                            </label>
                            <input name="INN"
                                   v-model="profile.Inn"
                                   v-validate="{ required: this.passportFieldsRequired && passportFields.Inn, innfl: profile.DocumentType !== 2, regex: /^[a-zа-яё0-9]*$/iu }"
                                   @blur=""
                                   data-vv-as="ИНН"
                                   data-vv-scope="docs"
                                   :class="['input-text', {'input-error': errors.has('INN', 'docs')}]" type="text">
                            <span class="field-validation-valid">{{ errors.first('INN', 'docs') }}</span>
                        </div>
                    </div>
                    <div class="profile-images right" :class="['thumbnail-img-block', {'input-error': errors.has('dropFiles2')}]">
                        <div class="form-field">
                            <div class="file-upload-zone" style="min-height:150px">
                                <input type="file" id="dropFiles2" ref="dropFiles2"
                                       v-validate ="{ rules: { required: this.dropFiles2Required} }"
                                       data-vv-scope="docs"
                                       name="dropFiles2" class="file-upload-zone-btn" accept=".jpg,.jpeg,.png" multiple />
                                <label id="dropFiles2BtnLbl" for="dropFiles2"
                                       :class="{'input-error': errors.has('dropFiles2', 'docs')}"
                                       class="file-upload-zone-lbl">{{ passportFields.dropFilesText }}</label>
                            </div>
                        </div>
                        <div class="margin-top-20">
                            <div class="thumbnail-img" v-for="(img, i) of profile.Images">
                                <img :src="img.FileData" v-if="img.FileData" />
                                <img :src="img.FileName" v-else-if="img.FileName" />
                                <div class="thumbnail-img-delete" @click="removeDocument(i)"></div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div :class="['block-in-page', {'notAllowed': profile.PaymentSettings != null &&
            (profile.PaymentSettings.VerificationState === VerificationStates.NeedToCheck || profile.PaymentSettings.VerificationState === VerificationStates.Verified) }]"
                 :style="{display: tabs.active === 'card' ? 'block' : 'none'}">

                <div class="error" v-if="profile.PaymentSettings.VerificationState === 1">
                    Данные банковской карты находятся на проверке
                </div>
                <div class="approve" v-if="profile.PaymentSettings.VerificationState === 2">
                    Данные банковской карты успешно проверены
                </div>
                <div class="error" v-if="profile.PaymentSettings.VerificationState === 3">
                    Данные банковской карты были отклонены по следующей причине:
                    <p>{{ profile.PaymentSettings.Comment }}</p>
                </div>

                <div class="error" v-if="errorMessage">
                    {{ errorMessage.message }}
                </div>

                <div class="profile-edit" v-if="errorMessage == null">
                    <div class="profile-data">
                        <div class="margin-bottom-20">
                            Банковская карта должна принадлежать «{{
                            [profile.LastName,profile.FirstName,profile.MiddleName].join(' ').trim() }}» – перевод будет
                            осуществляться на Ваше имя.
                        </div>
                        <div class="form-field">
                            <label class="input-text-lbl">
                                БИК банка
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <input name="BankBik"
                                   v-model="profile.PaymentSettings.BankBik"
                                   v-validate="{ rules: { required: true, bik: true} }"
                                   data-vv-scope="card"
                                   data-vv-as="БИК банка"
                                   @input="onBankBikChanged"
                                   :class="['input-text', {'input-error': errors.has('BankBik', 'card')}]" type="text">
                            <span class="field-validation-valid">{{errors.first('BankBik', 'card')}}</span>
                        </div>
                        <div class="form-field">
                            <label class="input-text-lbl">
                                Корреспондентский счёт
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <input name="BankCorrAccount"
                                   v-model="profile.PaymentSettings.BankCorrAccount"
                                   v-validate="{ rules: { required: true, cs: profile.PaymentSettings.BankBik } }"
                                   data-vv-scope="card"
                                   data-vv-as="Корреспондентский счёт"
                                   :class="['input-text', {'input-error': errors.has('BankCorrAccount', 'card')}]"
                                   type="text">
                            <span class="field-validation-valid">{{errors.first('BankCorrAccount', 'card')}}</span>
                        </div>
                        <div class="form-field">
                            <label class="input-text-lbl">
                                Наименование банка
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <input name="BankName"
                                   v-model="profile.PaymentSettings.BankName"
                                   v-validate="{ rules: { required: true} }"
                                   data-vv-scope="card"
                                   data-vv-as="Наименование банка"
                                   :class="['input-text', {'input-error': errors.has('BankName', 'card')}]" type="text">
                            <span class="field-validation-valid">{{errors.first('BankName', 'card')}}</span>
                        </div>
                        <div class="form-field">
                            <label class="input-text-lbl">
                                Расчётный счёт
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <input name="BankPaymentAccount"
                                   v-model="profile.PaymentSettings.BankPaymentAccount"
                                   v-validate="{ rules: { required: true, rs: profile.PaymentSettings.BankBik} }"
                                   data-vv-scope="card"
                                   data-vv-as="Расчётный счёт"
                                   :class="['input-text', {'input-error': errors.has('BankPaymentAccount', 'card')}]"
                                   type="text">
                            <span class="field-validation-valid">{{errors.first('BankPaymentAccount', 'card')}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="block-in-page" :style="{display: tabs.active === 'external' ? 'block' : 'none'}">
                <div class="error" v-if="errorMessage">
                    {{ errorMessage.message }}
                </div>
                <div class="profile-edit" v-if="errorMessage == null">
                    <div class="profile-data">
                        <div class="margin-bottom-20">
                            Способы авторизации
                        </div>
                        <div class="form-field external-login-item" v-for="externalItem of external">
                            <a :href="externalItem.Link" target="_blank">
                                <img src="../../img/u57.png" width="50px" />
                            </a>
                            <div>
                                <span>{{externalItem.providerName}}</span>
                                <a :href="externalItem.attachLink" v-if="externalItem.data == null">Привязать</a>
                                <a href="#" class="red-text" v-else @click.stop="onExternalRemove(externalItem)">Отвязать</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <popup-window ref="ppPolicy" :title="'Политика конфиденциальности сервиса'" :width="800" :height="'90%'">
            <p class="p-header-1"></p>
            <template v-if="info.PolicyFile">
                <iframe v-if="fileExtensionIsHtml(info.PolicyFile)" :src="info.PolicyFile"></iframe>
                <pdf-viewer v-else ref="pdfViewPolicy"></pdf-viewer>
            </template>
        </popup-window>

        <popup-window ref="ppRules" :title="'Правила программы'" :width="800" :height="'90%'">
            <p class="p-header-1"></p>
            <template v-if="info.RulesFile">
                <iframe v-if="fileExtensionIsHtml(info.RulesFile)" src="info.RulesFile"></iframe>
                <pdf-viewer v-else ref="pdfViewRules"></pdf-viewer>
            </template>
        </popup-window>

        <popup-window ref="ppAvatar" :title="'Настройте фото профиля'" :width="800" @onClose="onCloseAvatarModal()">
            <p class="p-header-1"></p>
            <div class="upload-img-sett">
                <img id="sourceImage" :src="uploadedFile.FileData" v-if="uploadedFile != null" style="max-width:700px;"/>
            </div>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn btn-primary" @click="onSaveAvatarModal()">Выбрать</button>
                <button type="button" class="btn" @click="closeAvatarModal()">Отмена</button>
            </div>
        </popup-window>

        <popup-window ref="ppChangePassword" :title="'Смена пароля'" :width="600">
            <div class="form-field">
                <input class="input-text" name="PasswordChanging" placeholder="Старый пароль" type="password"
                       v-validate="'required'"
                       v-model="password.oldPassword"
                       data-vv-as="Старый пароль"
                       data-vv-scope="changingPassword"
                       @input="password.error = null"
                       :class="['input-text', {'input-error': errors.has('PasswordChanging', 'changingPassword')}]"
                />
                <span class="field-validation-valid">{{ errors.first('PasswordChanging', 'changingPassword') }}</span>
            </div>
            <div class="form-field">
                <input class="input-text" name="newPassword" placeholder="Новый пароль" type="password"
                       v-validate="{required: true}"
                       v-model="password.newPassword"
                       data-vv-as="Новый пароль"
                       data-vv-scope="changingPassword"
                       @input="onNewPasswordChange"
                       :class="['input-text', {'input-error': password.regexError || errors.has('newPassword', 'changingPassword')}]"
                />
                <span class="field-validation-valid">{{ errors.first('newPassword', 'changingPassword') }}{{password.regexError}}</span>
            </div>
            <div class="form-field">
                <input class="input-text" name="newPasswordConfirm" placeholder="Повторите пароль" type="password"
                       v-validate="{required: true, confirmed:password.newPassword}"
                       v-model="password.newPasswordConfirm"
                       data-vv-as='"Повторите пароль"'
                       data-vv-scope="changingPassword"
                       @input="password.error = null"
                       :class="['input-text', {'input-error': errors.has('newPasswordConfirm', 'changingPassword')}]"
                />
                <span class="field-validation-valid">{{ errors.first('newPasswordConfirm', 'changingPassword') }}{{password.error}}</span>
            </div>
            <div class="form-actions">
                <div class="form-btns">
                    <button type="button" class="btn btn-primary" @click="changePassword()">
                        Сменить
                    </button>
                </div>
            </div>
        </popup-window>

        <vue-headful title="Профиль" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import BackendApi from '../backendApi'
    import UI from '../helpers/ui-helpers'
    import moment from 'moment'
    import cropper from '../../../node_modules/cropper/dist/cropper'
    import croppercss from '../../../node_modules/cropper/dist/cropper.css'
    import config from "../config";
    import {VerificationStates} from '../enums'
    import _ from 'lodash'

    let backendApi = new BackendApi();

    let localizedFields = {
        'FirstName': 'Имя',
        'LastName': 'Фамилия',
        'Email': 'Email',
        'PhoneNumber': 'Телефон',
        'BirthDateFormatted': 'Дата рождения',
        'Sex': 'Пол',

        'PassportSeries': 'Серия паспорта',
        'PassportNumber': 'Номер паспорта',
        'PassportIssuedBy': 'Кем выдан',
        'PassportIssuedCode': 'Номер подразделения',
        'PassportIssuedDateFormatted': 'Дата выдачи',
        'PassportRegistrationAddress': 'Адрес регистрации',
        'Inn': 'ИНН'
    };

    export default {
        name: "profile",

        props: ['info'],

        data(){
            return {
                profile: null,
                uploadedFile: null,
                genders:[
                    {Value: false, Name: 'Женский'},
                    {Value: true, Name: 'Мужской'}
                ],
                tabs: {
                    active: 'info'
                },
                documentTypes: [
                    { Id: 1, Name: 'Паспорт гражданина Российской Федерации' },
                    { Id: 2, Name: 'Паспорт иностранного гражданина' },
                    { Id: 3, Name: 'Вид на жительство' }
                ],
                birthDateCompleted: false,
                external:[],
                password: {
                    oldPassword: null,
                    newPassword: null,
                    newPasswordConfirm: null,
                    error: null
                },
                VerificationStates: VerificationStates
            }
        },

        computed: {
            errorMessage(){
                if(this.tabs.active === 'docs'){
                    if(!this.profile.BirthDateFormatted && this.profile.Sex === ''){
                        return { message: `Внесите данные в поля «Дата рождения» и «Пол», нажмите «Сохранить»,
                        после чего будет возможно внести данные документов`, type: 'birthdate' };
                    }
                    if(!this.profile.BirthDateFormatted && this.profile.Sex !== ''){
                        return {
                            message: `Поля «Данные документов» станут доступны после внесения данных в поле «Дата рождения» на вкладке «Основные данные»`, type: 'birthdate' };
                    }
                    if(this.profile.BirthDateFormatted && this.profile.Sex === ''){
                        return { message: `Поля «Данные документов» станут доступны после внесения данных в поле «Пол» на вкладке «Основные данные»`, type: 'birthdate' };
                    }
                    if(this.profile.BirthDateFormatted && this.profile.Sex !== '' && !this.birthDateCompleted){
                        return { message: `нажмите «Сохранить» на вкладке «Основные данные»`, type: 'birthdate' };
                    }
                }

                if(this.errors.items.length) {
                    for(let error of this.errors.items.filter(x => x.scope === this.tabs.active)){
                        if(localizedFields[error.field]){
                            if(error.rule === 'regex'){
                                return { message: `Проверьте формат данных в поле «${localizedFields[error.field]}»`, type: 'field' };
                            }
                            if(error.rule === 'required'){
                                return { message: `Заполните поле «${localizedFields[error.field]}»`, type: 'field' };
                            }
                            if(error.rule === 'email'){
                                return { message: `Проверьте введённый адрес в поле «${localizedFields[error.field]}»`, type: 'field' };
                            }
                        }
                    }
                }

                if(this.tabs.active === 'docs' && this.passportFieldsRequired && this.profile.Images.length < 2){
                    return { message: 'Загрузите не менее двух фотографий документов', type: 'images' };
                }

                if(this.tabs.active === 'card'){
                    //проверка убрана по запросу https://trello.com/c/QWnpnwFf
                    //if(this.profile.PassportVerificationState !== 2){
                    //    return { message: 'Требуется заполнить раздел «Документы»', type: 'card' };
                    //}
                }

                return null;
            },

            passportFieldsRequired() {
                //let passportFields = this.passportFields;
                return this.info.User && this.hasClaims(this.info.User.DynamicRole, this.claimEnums.bonusSpend) &&
                    (
                        (this.profile.PassportIssuedCountry != null && this.profile.PassportIssuedCountry !== '') ||
                        (this.profile.PassportSeries != null && this.profile.PassportSeries !== '') ||
                        (this.profile.PassportNumber != null && this.profile.PassportNumber !== '') ||
                        (this.profile.PassportIssuedCode != null && this.profile.PassportIssuedCode !== '') ||
                        (this.profile.PassportIssuedDateFormatted != null && this.profile.PassportIssuedDateFormatted !== '') ||
                        (this.profile.PassportIssuedBy != null && this.profile.PassportIssuedBy !== '') ||
                        (this.profile.Inn != null && this.profile.Inn !== '') ||
                        (this.profile.Images.length !== 0)
                    );
            },

            dropFiles2Required(){
                return (this.passportFieldsRequired && !this.profile.Images.length);
            },

            passportFields() {
                switch (this.profile.DocumentType) {
                    case 2:
                        // паспорт ин. гражданина
                        return {
                            PassportIssuedCountry: true,
                            PassportSeries: false,
                            PassportNumber: true,
                            PassportIssuedBy: true,
                            PassportIssuedCode: false,
                            PassportIssuedDateFormatted: true,
                            PassportRegistrationAddress: true,
                            Inn: true,
                            dropFilesText: 'Прикрепите фотографию основного разворота паспорта, вида на жительство (при наличии), разрешения на временное проживание (при наличии), действующей прописки и ИНН'
                        }
                    case 3:
                        // вид на жительство
                        return {
                            PassportIssuedCountry: false,
                            PassportSeries: true,//false,
                            PassportNumber: true,
                            PassportIssuedBy: true,
                            PassportIssuedCode: false,
                            PassportIssuedDateFormatted: true,
                            PassportRegistrationAddress: true,
                            Inn: true,
                            dropFilesText: 'Прикрепите фотографию основного разворота паспорта, вида на жительство (при наличии), разрешения на временное проживание (при наличии), действующей прописки и ИНН'
                        }
                    default:
                        return {
                            PassportIssuedCountry: false,
                            PassportSeries: true,
                            PassportNumber: true,
                            PassportIssuedBy: true,
                            PassportIssuedCode: true,
                            PassportIssuedDateFormatted: true,
                            PassportRegistrationAddress: true,
                            Inn: true,
                            dropFilesText: 'Прикрепите фотографию второго разворота паспорта, разворота паспорта с действующей пропиской и ИНН.'
                        }
                }
            },

            PassportSeriesMask() {
                return this.profile.DocumentType === 1 ? '## ##' : '##';
            },

            PassportSeriesMaxLength() {
                if(this.passportFieldsRequired && this.passportFields.PassportSeries) {
                    return this.profile.DocumentType === 1 ? 4 : 2;
                } else {
                    return false;
                }
            },

            PassportNumberMaxLength() {
                if(this.passportFieldsRequired && this.passportFields.PassportNumber && this.profile.DocumentType !== 2) {
                    return this.profile.DocumentType === 3 ? 7 : 6;
                } else {
                    return false;
                }
            }
        },

        methods: {
            onBankBikChanged: _.debounce(function () {
                let vm = this;
                vm.callApiWrapper(backendApi.getBankNameByBik(vm.profile.PaymentSettings.BankBik))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            //UI.toastr.error('Ошибка во время загрузки');
                        } else {
                            if (resp.data) {
                                vm.profile.PaymentSettings.BankName = resp.data;
                            }
                        }
                    });
            }, 500),

            onNewPasswordChange() {
                this.password.error = null;

                if (!this.password.newPassword || !this.password.newPassword.trim()) {
                    this.password.regexError = null;
                } else {
                    let newpass = this.password.newPassword;

                    if (newpass.length < 6) {
                        this.password.regexError = 'Введите минимум 6 символов';
                    }
                    else if (!/(?=.*\d).*\D.*/ig.test(newpass)) {
                        this.password.regexError = 'Обязательно наличие и букв и цифр';
                    }
                    else if (!/(?=.*[A-ZА-Я]).*[a-zа-я].*/g.test(newpass)) {
                        this.password.regexError = 'Обязательно наличие заглавной и прописной буквы';
                    }
                    else{
                        this.password.regexError = null;
                    }
                }
            },

            fileExtensionIsHtml(filename) {
                return filename.endsWith('.html');
            },

            changePassword(){
                let vm = this;

                this.$validator.validateAll('changingPassword').then(result => {
                    if(!result || vm.password.regexError){
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        vm.password.error = null;
                        this.callApiWrapper(backendApi.userChangePassword(vm.password.oldPassword, vm.password.newPassword)).then(function (resp) {
                            if (resp.hasError) {
                                if (resp.status === 6) {
                                    vm.password.error = 'Введён неверный пароль';
                                }
                                else {
                                    UI.toastr.error('Ошибка при смене пароля');
                                }
                            }
                            else {
                                UI.toastr.success('Пароль изменён');

                                vm.$nextTick(() => {
                                    vm.$refs['ppChangePassword'].close();
                                });
                            }
                        });
                    }
                });
            },
            onExternalRemove(externalItem){
                if(confirm('Вы уверены что хотите удалить привязку к ' + externalItem.providerName)){
                    this.callApiWrapper(backendApi.removeExternalLogin(externalItem.providerName))
                        .then(function (resp) {
                            if (resp.hasError && resp.status !== 401) {
                                UI.toastr.error('Ошибка во время удаления привязки');
                            }
                            else {
                                UI.toastr.success('Привязка к ' + externalItem.providerName + ' удалена');
                                externalItem.data = null;
                            }
                        });
                }
            },

            loadData() {
                let vm = this;
                return this.callApiWrapper(backendApi.profileLoad())
                    .then(function (resp) {
                        //console.info('resp', resp)
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки');
                        }
                        else {
                            if (resp.data) {
                                let obj = Object.assign(resp.data, { FileName: null, DeleteImage: false });
                                if(obj.BirthDate)
                                {
                                    obj.BirthDateFormatted = vm.formatDate(obj.BirthDate);
                                }
                                if(obj.PassportIssuedDate)
                                {
                                    obj.PassportIssuedDateFormatted = vm.formatDate(obj.PassportIssuedDate);
                                }

                                vm.birthDateCompleted = (obj.BirthDate ? true : false) && obj.Sex !== null;

                                for(let login of obj.ExternalLogins){
                                    let externalItem = vm.external.find(x => x.providerName === login.ProviderName);
                                    if(externalItem){
                                        externalItem.data = login;
                                    }
                                }

                                vm.profile = obj;

                                if (vm.$route.query.tabs === 'docs' && vm.info.User && vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend)) {
                                    vm.tabs.active = 'docs';
                                    vm.$validator.validateAll('docs');
                                } else if (vm.$route.query.tabs === 'card' && vm.profile.ProjectsHavePhysicalBankCardReward
                                    && vm.info.User && vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend)) {
                                    vm.tabs.active = 'card';
                                    vm.$validator.validateAll('card');
                                }
                            }
                        }
                    });
            },

            saveData() {
                let vm = this;

                let saveObj = Object.assign({}, vm.profile);
                for (let prop in saveObj) {
                    if (saveObj[prop] === '') {
                        saveObj[prop] = null;
                    }
                }

                this.$validator.validateAll(this.tabs.active).then(result => {
                    //console.info('result', result)
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        // доп. проверки
                        if(vm.tabs.active === 'docs' && vm.passportFieldsRequired && vm.profile.Images.length < 2){
                            UI.toastr.error('Загрузите не менее двух фотографий документов');
                            return;
                        }

                        UI.blockUI('.dataContent', 'Сохранение...');

                        let defferedAction;
                        let timeZone = new Date().getTimezoneOffset();
                        if(vm.tabs.active === 'info'){
                            defferedAction = backendApi.profileSaveInfo(saveObj);
                        }else if(vm.tabs.active === 'docs'){
                            defferedAction = backendApi.profileSaveDocs(saveObj);
                        }
                        else{
                            defferedAction = backendApi.profileSaveCard(saveObj.PaymentSettings);
                        }
                        defferedAction.then(function (response) {
                            UI.unblockUI('.dataContent');
                            if (response.hasError) {
                                if(response.status === 8)
                                {
                                    UI.toastr.error('Такой email уже используется');
                                }
                                else {
                                    UI.toastr.error('Ошибка при сохранении Профиля');
                                }
                            } else {
                                UI.toastr.success('Успешно сохранено');

                                vm.$emit('user-updated')

                                vm.birthDateCompleted = true;

                                // todo: загрузка blockUI
                                vm.loadData();
                            }
                        });
                    }
                });
            },

            // onTermsClick() {
            //     this.$refs.ppTerms.show();
            // },

            closeAvatarModal(){
                this.$refs.ppAvatar.close();
            },

            onCloseAvatarModal(){
                $('[name="dropFiles"]').val('');
            },

            onSaveAvatarModal() {
                let vm = this;

                vm.profile.DeleteImage = false;
                vm.profile.FileName = vm.uploadedFile.FileName;
                vm.profile.FileData = $('#sourceImage').cropper('getCroppedCanvas').toDataURL('image/jpeg');
                vm.$refs.ppAvatar.close();
            },

            removeImage(){
                this.profile.DeleteImage = true;
                this.profile.FileName = null;
                this.profile.FileData = null;
                this.profile.Image = null;
            },

            removeDocument(i){
                if(confirm('Удалить файл?')) {
                    this.profile.Images.splice(i, 1);
                    this.$refs.dropFiles2.value = '';
                }
            },

            onChangeDate(item, formatted, raw) {
                item[raw] = moment(item[formatted], 'DD.MM.YYYY').format();
            },

            onShowRulesClick(){
                let vm = this;
                vm.$refs.ppRules.show();
                vm.$nextTick(() => {
                    if (vm.$refs.pdfViewRules)
                        vm.$refs.pdfViewRules.show(config.apiUrl + vm.info.RulesFile);
                });
            },

            onShowPolicyClick(){
                let vm = this;

                vm.$refs.ppPolicy.show();
                vm.$nextTick(() => {
                    if (vm.$refs.pdfViewPolicy)
                        vm.$refs.pdfViewPolicy.show(config.apiUrl + vm.info.PolicyFile);
                });
            }
        },

        mounted(){
            let vm = this;
            UI.blockUI('.dataContent', 'Загрузка...');
            this.loadData().then((response) => {
                UI.unblockUI('.dataContent');

                $(document).on('change', '[name="dropFiles"]', function () {
                    if (this.files && this.files[0]) {
                        if(this.files[0].type !== 'image/jpeg' && this.files[0].type !== 'image/png'){
                            UI.toastr.error('Неверный тип. Выберите другой файл');
                            $('[name="dropFiles"]').val('');
                        }
                        else if (this.files[0].size > 5 * 1024 * 1024) {
                            UI.toastr.error('Превышен размер. Выберите другой файл');
                            $('[name="dropFiles"]').val('');
                        } else {
                            vm.uploadedFile = {FileName: this.files[0].name, FileData: null};
                            let reader = new FileReader();
                            reader.onload = function (e) {
                                vm.uploadedFile.FileData = e.target.result;

                                vm.$nextTick(() => {
                                    $('#sourceImage').cropper({
                                        aspectRatio: 1
                                    });

                                });

                                vm.$refs.ppAvatar.show();
                            };
                            reader.readAsDataURL(this.files[0]);
                        }

                    }
                });

                $(document).on('change', '[name="dropFiles2"]', function () {
                    if (this.files && this.files.length) {
                        for (let file of this.files) {
                            if(this.files[0].type !== 'image/jpeg' && this.files[0].type !== 'image/png'){
                                UI.toastr.error('Неверный тип. Выберите другой файл');
                                $('[name="dropFiles"]').val('');
                            }
                            else if (file.size > 50 * 1024 * 1024) {
                                UI.toastr.error('Превышен размер. Выберите другой файл');
                                $('[name="dropFiles2"]').val('');
                            } else {
                                let img = {FileName: file.name, FileData: null, Delete: false};
                                let reader = new FileReader();
                                reader.onload = function (e) {
                                    img.FileData = e.target.result;

                                    vm.profile.Images.push(img);
                                };
                                reader.readAsDataURL(file);
                            }
                        }
                    }
                });
            });


            let baseHost = location.origin;
            if(baseHost.indexOf('localhost') > -1 && config.apiUrl){
                baseHost = config.apiUrl;
            }
            let redirectUri = `${baseHost}/AttachCallback/?provider=%provider%&returnUrl=${encodeURI(location.href)}`;

            if (vm.info.ExternalVk) {
                vm.external.push({providerName: 'Vk', data: null});
            }
            if (vm.info.ExternalGoogle) {
                vm.external.push({providerName: 'Google', data: null});
            }
            //if (vm.info.ExternalFacebook) {
            //    vm.external.push({providerName: 'Facebook', data: null});
            //}
            for(let item of vm.external){
                switch (item.providerName) {
                    case 'Vk':
                        item.attachLink =
                            "https://oauth.vk.com/authorize" +
                            "?client_id=" + encodeURIComponent(config.vkAppId) +
                            "&redirect_uri=" + encodeURIComponent(redirectUri.replace('%provider%', 'vk')) +
                            "&scope=" + encodeURIComponent(config.vkAppScopes) +
                            "&response_type=code" + "&v=" + encodeURIComponent(config.vkVersion);
                        break;
                    case 'Google':
                        item.attachLink =
                            "https://accounts.google.com/o/oauth2/auth" +
                            "?client_id=" + encodeURIComponent(config.googleAppId) +
                            "&redirect_uri=" + encodeURIComponent(redirectUri.replace('%provider%', 'google')) +
                            "&access_type=offline&prompt=consent" +
                            "&scope=" + encodeURIComponent(config.googleAppScopes) +
                            "&response_type=code";
                        break;
                    //case 'Facebook':
                    //    item.attachLink =
                    //        "https://www.facebook.com/dialog/oauth" +
                    //        "?client_id=" + encodeURIComponent(config.facebookAppId) +
                    //        "&redirect_uri=" + encodeURIComponent(`${baseHost}/AttachCallback/?provider=facebook`) +
                    //        "&scope=" + encodeURIComponent(config.facebookAppScopes) +
                    //        "&response_type=code";
                    //    break;
                }
            }
        },

        destroyed(){
            $(document).off('change', '[name="dropFiles"]');
            $(document).off('change', '[name="dropFiles2"]');
        }
    }
</script>

<style scoped>
    .external-login-item{
        display: flex;
        align-items: center;
    }
    .external-login-item div{
        display: flex;
        flex-direction: column;
    }
    .external-login-item div span{
        margin-bottom: 5px;
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/Profile.vue